var map = {
	"./api.svg": 1987,
	"./apps.svg": 1988,
	"./arrow-left-line.svg": 986,
	"./arrow-right-line.svg": 987,
	"./bell.svg": 988,
	"./chart-line.svg": 1989,
	"./chat-bubble-question.svg": 1990,
	"./chevron-down.svg": 989,
	"./clapper.svg": 1991,
	"./clock.svg": 1992,
	"./cog.svg": 1993,
	"./controller.svg": 1994,
	"./download.svg": 990,
	"./export.svg": 991,
	"./folder-open.svg": 1995,
	"./inbox.svg": 1996,
	"./key.svg": 1997,
	"./lightning-bolt.svg": 1998,
	"./lock.svg": 1999,
	"./megaphone.svg": 2000,
	"./message.svg": 2001,
	"./messages.svg": 2002,
	"./restore-page.svg": 2003,
	"./rotate-auto.svg": 2004,
	"./search-insights.svg": 2005,
	"./smiley.svg": 2006,
	"./tag.svg": 2007,
	"./user-card.svg": 2008,
	"./user-group.svg": 2009,
	"./user.svg": 2010,
	"./whatsapp.svg": 2011,
	"./work.svg": 2012,
	"./workflow.svg": 2013
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1087;